// amplitude tracking
import { syncAmplitudeConsent } from './amplitude';
window.resolveAmpliReady = null;
window.ampliReadyPromise = new Promise((resolve) => {
  window.resolveAmpliReady = resolve;
});

document.addEventListener('DOMContentLoaded', () => {
  // Wait for ampli.load() to complete before syncing consent — DOMContentLoaded
  // can fire before the deferred Vite bundle finishes initializing ampli.
  window.ampliReadyPromise?.then(() => syncAmplitudeConsent());

  // OneTrust documents consent-state access through OnetrustActiveGroups
  // and updates via OneTrustGroupsUpdated.
  window.addEventListener('OneTrustGroupsUpdated', () => {
    syncAmplitudeConsent();
  });
});





// main js
loadjs.ready(["jquery"], {
  success: function () {
    // escape button closes mobile menu
    $(document).keyup(function (e) {
      if (e.keyCode === 27) {
        $("body").removeClass("offcanvas-is-visible");
        $("html").removeClass("scroll-locked");
        $(".nav-desktop .nav-dropdown").removeClass("active");
      }
    });

    // close dropdown menus on outside of menu click
    $(document).on("click", function (e) {
      // console.log('e.target', $(e.target));
      // console.log('parent', $(e.target).parent());
      if (
        !$(e.target).closest(".nav-dropdown.active").length &&
        $(e.target).parent(".dropdown-wrapper")
      ) {
        $(".nav-desktop .nav-dropdown").removeClass("active");
      }
    });

    $(document).ready(function () {
      // Mobile slide-out nav
      $(".menu-btn").on("click", function (e) {
        $("body").toggleClass("offcanvas-is-visible");
        $("html").toggleClass("scroll-locked");
        $(".offcanvas-container").focus();

        $(this).toggleClass("is-active");
        if ($(this).attr("aria-expanded") === "false") {
          $(this).attr("aria-expanded", "true");
        } else {
          $(this).attr("aria-expanded", "false");
        }
        e.stopPropagation();
      });

      // mobile menu close button
      $(".menu-trigger.trigger-close").on("click", function () {
        $("body").removeClass("offcanvas-is-visible");
        $("html").removeClass("scroll-locked");
      });

      $(document).click(function (e) {
        var container = $(".offcanvas-container");
        if (!container.is(e.target) && !container.has(e.target).length) {
          $("body").removeClass("offcanvas-is-visible");
          $("html").removeClass("scroll-locked");
        }
      });

      var mq = window.matchMedia("(min-width: 53em)");

      // Utility: update tabbing for all dropdowns
      function updateDropdownTabbing() {
        $(".nav-level-1.nav-dropdown").each(function () {
          var $dropdown = $(this);
          var isOpen = $dropdown.hasClass("active");
          var $submenuLinks = $dropdown.find(".nav-level-2 a, .nav-level-3 a");
          if (isOpen) {
            $submenuLinks.attr("tabindex", "0");
          } else {
            $submenuLinks.attr("tabindex", "-1");
          }
        });
      }
      // Call on page load
      updateDropdownTabbing();

      // desktop nav
      if (mq.matches) {
        $(".nav-desktop .nav-dropdown.active *").on("click", function () {
          $(".nav-dropdown").removeClass("active");
          updateDropdownTabbing();
        });
      }

      // desktop nav
      $(".nav-desktop .nav-dropdown").on("click", function () {
        $(".nav-desktop .nav-dropdown.active").not(this).removeClass("active");
        $(this).toggleClass("active");
        setTimeout(updateDropdownTabbing, 0);
      });

      // mobile nav
      $(".nav-offcanvas .nav-dropdown > a").on("click", function () {
        var $parent = $(this).parent();
        if ($parent.hasClass("active")) {
          $parent.removeClass("active");
        } else {
          $parent.toggleClass("active");
        }
        setTimeout(updateDropdownTabbing, 0);
      });

      // Also update tabbing after any nav-level-1 root is toggled by keyboard
      $(".nav-level-1.nav-dropdown > a").on("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          setTimeout(updateDropdownTabbing, 0);
        }
      });

      var scrollContainer = $(window);
      var $body = $("body");
      var $stickyLinks = $(
        ".scroll-header-container a, .scroll-header-container button, .scroll-header-container [tabindex]"
      );
      $(".scroll-header-container").addClass("add-transition");

      scrollContainer.on("scroll load", function () {
        if (scrollContainer.scrollTop() >= 100) {
          $body.addClass("scroll-header-is-visible");
          $stickyLinks.attr("tabindex", "0");
        } else {
          $body.removeClass("scroll-header-is-visible");
          $stickyLinks.attr("tabindex", "-1");
        }

        if (scrollContainer.scrollTop() >= 300) {
          $body.addClass("snav-is-visible");
          $(".luke-cta-container:not(.hide)").addClass("show");
        } else {
          $body.removeClass("snav-is-visible");
        }
      });

      // cta-luke
      $(".luke-cta-container .cta-close-button").on("click", function () {
        $(".luke-cta-container").addClass("hide");
        $(".luke-cta-container").removeClass("show");
      });

      $(".luke-cta-container .minimized").on("click", function () {
        $(".luke-cta-container").removeClass("hide");
        $(".luke-cta-container").addClass("show");
      });

      // mobile menu close button and trap sequence
      function trapFocusInMobileMenu() {
        var $offcanvas = $(".offcanvas-container");
        var $focusable = $offcanvas
          .find(
            'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
          )
          .filter(":visible");
        var $first = $focusable.first();
        var $last = $focusable.last();

        $offcanvas.on("keydown.trapFocus", function (e) {
          if (e.key === "Tab") {
            if (e.shiftKey) {
              // Shift + Tab
              if (document.activeElement === $first[0]) {
                $last[0].focus();
                e.preventDefault();
              }
            } else {
              // Tab
              if (document.activeElement === $last[0]) {
                $first[0].focus();
                e.preventDefault();
              }
            }
          }
          // Optional: ESC to close menu
          if (e.key === "Escape") {
            $(".menu-trigger.trigger-close").click();
          }
        });
      }

      // When mobile menu opens, trap focus and focus the close button
      $(".menu-btn").on("click", function () {
        setTimeout(function () {
          if ($("body").hasClass("offcanvas-is-visible")) {
            var $closeBtn = $(".menu-trigger.trigger-close");
            $closeBtn.attr("tabindex", "0").focus();
            trapFocusInMobileMenu();
          } else {
            // Remove trap event when menu closes
            $(".offcanvas-container").off("keydown.trapFocus");
            // Optionally, return focus to menu button
            $(".menu-btn").focus();
          }
        }, 100);
      });

      // Ensure close button is always tabbable when menu is open
      $(".menu-trigger.trigger-close").attr("tabindex", "0");
    });
  },
});

// freeform form label js
document
  .querySelectorAll(".remodal .freeform-row input")
  .forEach(function (input) {
    // Get the label. Adjust selector if your label is not a sibling.
    var label = input.closest("div").querySelector(".freeform-label");
    if (!label) return;

    // Helper to move label up
    function moveLabelUp() {
      label.style.top = "23px";
      label.style.fontSize = "12px";
    }
    // Helper to reset label
    function resetLabel() {
      if (!input.value) {
        label.style.top = "";
        label.style.fontSize = "";
      }
    }

    function checkLabel(event) {
      input.addEventListener(event, function () {
        if (input.value) {
          moveLabelUp();
        } else {
          resetLabel();
        }
      });
    }

    // On focus or click, move label up
    input.addEventListener("focus", moveLabelUp);
    input.addEventListener("click", moveLabelUp);

    checkLabel("blur");
    checkLabel("input");

    window.addEventListener("load", function () {
      if (input.value) {
        moveLabelUp();
      }
    });

  });
